import { render, staticRenderFns } from "./StorageUsageDialog.vue?vue&type=template&id=8af5b49c&"
import script from "./StorageUsageDialog.vue?vue&type=script&lang=js&"
export * from "./StorageUsageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports